.biel-terms-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: var(--biel-bot-content-font-family);
  color: var(--biel-terms-modal-color);
}

.biel-terms-modal-content {
  background-color: var(--biel-terms-modal-bg-color);
  padding: 20px;
  border-radius: var(--biel-bot-content-border-radius);
  box-shadow: var(--biel-terms-modal-box-shadow);
  max-width: var(--biel-bot-content-max-width);
  width: 90%;
  position: relative;
}

.biel-terms-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biel-terms-modal-title {
  font-size: var(--biel-header-font-size);
  font-weight: var(--biel-header-font-weight);
  margin: 0;
}

.biel-terms-modal-text {
  margin-bottom: 10px;
}

.biel-terms-modal-text a {
  color: var(--biel-terms-modal-link-color);
  text-decoration: none;
}

@media (hover: hover) {
  .biel-terms-modal-text a:hover {
    text-decoration: underline;
  }
}

.checkbox-container input {
  transform: scale(1.2);
}

.checkbox-container {
  margin: 15px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn {
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: var(--biel-bot-content-font-family);
}

.decline-btn {
  background-color: var(--biel-white-hover-color);
  color: var(--biel-terms-modal-decline-btn-color);
}

@media (hover: hover) {
  .decline-btn:hover {
    background-color: var(--biel-terms-modal-decline-btn-hover-bg-color);
  }
}

.accept-btn {
  background-color: var(--biel-terms-modal-accept-btn-bg-color);
  color: var(--biel-terms-modal-accept-btn-color);
}

.accept-btn:disabled {
  background-color: var(--biel-terms-modal-accept-btn-bg-color-disabled);
  color: var(--biel-terms-modal-accept-btn-color-disabled);
  cursor: not-allowed;
}

@media (hover: hover) {
  .accept-btn:hover:enabled {
    background-color: var(--biel-terms-modal-accept-btn-bg-color-hover);
  }
}

.button-container {
  display: flex;
  margin-top: 15px;
}

.close-btn {
  background: none;
  border: none;
  color: var(--biel-terms-modal-close-btn-color);
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}

@media (hover: hover) {
  .close-btn:hover {
    opacity: 0.7;
  }
}

.close-btn:focus-visible {
  opacity: 0.7;
}
